<template>
  <div class="relative w-full mt-8">





    <h2 class="self-stretch justify-center text-neutral-900  text-2xl font-bold leading-9">Podsumowanie </h2>

    <div class="flex flex-col gap-5 mb-8 mt-4">

       
      <!-- Enrollment Start -->
  
          <div v-if="order.isBeforeEnrollmentStart()" class="flex flex-row gap-3 items-start">
            <ClockIcon class="w-6 h-6 flex-shrink-0" />
          <div class="flex flex-col flex-1">
            <div class="text-neutral-900 font-semibold text-base">
             Rozpoczęcie zapisów 
            </div>
             
              <div>
          <CountdownTimer 
            :targetDate="order.selectedGroup.enrollmentStart" 
            expiredMessage="Zapisy otwarte" 
          /></div>
          </div>
        </div>

        <div v-if="order.selectedGroup" class="flex flex-row gap-3 items-start h-12">
        <AcademicCapIcon class="w-6 h-6 flex-shrink-0" />
        <div class="flex flex-col flex-1">
          <div class="text-neutral-900 font-semibold text-base">
            {{ order.selectedGroup?.name }}
          </div>
          <div  class="text-neutral-600 text-sm" v-html="order.selectedGroup?.sessionsFormatted">
          </div> 
  
        </div>
      </div>

      <div v-if="order.selectedGroup?.location" class="flex flex-row gap-3 items-start h-12">
        <MapPinIcon class="w-6 h-6 flex-shrink-0" />
        <div class="flex flex-col flex-1">
          <div class="text-neutral-900 font-semibold text-base">
            {{ order.selectedGroup.location.name }}
          </div>
          <div class="text-neutral-600 text-sm">
            {{ order.selectedGroup.location.address || order.selectedGroup.location.description }}
          </div>
        </div>
      </div>


      <div v-if="order.selectedGroup?.start_date && order.selectedGroup?.end_date"
        class="flex flex-row gap-3 items-start h-12">
        <CalendarDaysIcon class="w-6 h-6 flex-shrink-0" />
        <div class="flex flex-col flex-1">
          <div class="text-neutral-900 font-semibold text-base">
            Kalendarz zajęć
          </div>
          <div class="text-neutral-600 text-sm">
            {{ order.selectedGroup?.durationFormatted || '' }}
          </div>
        </div>
      </div>

      
      


  
      <div v-if="order.selectedGroup?.hours && order.selectedGroup.hours.length > 0"
        class="flex flex-row gap-3 items-start h-12">
        <ClockIcon class="w-6 h-6 flex-shrink-0" />
        <div class="flex flex-col flex-1">
          <div class="text-neutral-900 font-semibold text-base">
            Rozpoczęcie zajęć
          </div>
          <div class="text-neutral-600 text-sm" v-html="order.selectedGroup.startF()">
          </div>
        </div>
       
      </div>

    </div>


    <div v-if="order.selectedGroup.hasTrial && !order.selectedGroup.noAvailability" class="w-full flex flex-col gap-2 justify-between py-4 border-t border-gray-300">
        <div class="flex gap-3">
          <div class="flex h-6 shrink-0 items-center ml-1">
            <input ref="checkonTrial" 
                    id="checkonTrial"
                    name="hasTrial" 
                    type="checkbox"
                    :value=true
                    :checked="order.onTrial"
                    @click="onTrialSelection($event)"
                    class="h-5 w-5 text-primary-500 checked:ring-primary-500 focus:ring-primary-500 border-gray-300 rounded" />
          </div>
          <label class="flex-1 text-neutral-900 font-semibold text-base" for="checkonTrial">
            Bezpłatne jednorazowe zajęcia próbne
          </label>
        </div>
         <div v-if="order.onTrial" class="text-neutral-600 text-sm ml-8 pl-1">
          <strong>Uczestnictwo</strong> tylko po podjęciu decyzji o kontynuacji zajęć
         </div>
      </div> 


    <div  class="border-t border-gray-300 " :class="usePadding ? '' : ''">
      <dl class="mt-4 space-y-3 text-sm font-medium text-gray-500">
        <div class="flex justify-between">
          <dt class="text-gray-900 text-base">Uczestnictwo</dt>
          <dd class="text-gray-900 text-base"> {{ $n(participantsPrice, 'currency') }}</dd>
        </div>
        <div v-if="addOnsPrice > 0" class="flex justify-between">
          <dt class="text-gray-900 text-base">Dodatki</dt>
          <dd class="text-gray-900 text-base">{{ $n(addOnsPrice, 'currency') }}</dd>
        </div>
        <div v-if="insuranceAmount > 0" class="flex justify-between">
          <dt class="text-gray-900 text-base">Ubezpieczenie</dt>
          <dd class="text-gray-900 text-base">{{ $n(insuranceAmount, 'currency') }}</dd>
        </div>

 


        <div v-if="showDiscount" class="flex justify-between items-center">
          <dt class="text-gray-900 text-base">Rabat</dt>
          <dd class="text-gray-900 text-base">
            <div class="flex items-center">
              <template v-if="discountApplied">

                <div class="flex items-center">

                  <button @click="removeDiscount"
                    class="ml-2 px-3 py-1 bg-primary-500 text-white rounded-full text-xs flex items-center">
                    <svg class="mr-1" focusable="false" width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path opacity="0.5" fill-rule="evenodd" clip-rule="evenodd"
                        d="M5.76372 0.441305L11.7795 6.4757C12.0735 6.76867 12.0735 7.24365 11.7795 7.53662L7.52046 11.7803C7.22643 12.0732 6.74973 12.0732 6.4557 11.7803L0.435789 5.74171C0.156657 5.46172 0 5.08308 0 4.68843V1.50036C0 0.671734 0.674166 0 1.50579 0H4.69951C5.09908 0 5.48213 0.158844 5.76372 0.441305ZM2.625 3.75C3.24632 3.75 3.75 3.24632 3.75 2.625C3.75 2.00368 3.24632 1.5 2.625 1.5C2.00368 1.5 1.5 2.00368 1.5 2.625C1.5 3.24632 2.00368 3.75 2.625 3.75Z"
                        fill="currentColor"></path>
                    </svg>
                    <span class="mr-2 truncate max-w-full">{{ discountCode }}</span>
                    <svg class="hover:text-red-500 text-white ml-1" focusable="false" fill="currentColor"
                      viewBox="0 0 16 16" width="12" height="12">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8 6.585l4.593-4.592a1 1 0 111.415 1.416L9.417 8l4.591 4.591a1 1 0 11-1.415 1.416L8 9.415l-4.592 4.592a1 1 0 11-1.416-1.416L6.584 8l-4.59-4.591a1 1 0 111.415-1.416L8 6.585z">
                      </path>
                    </svg>
                  </button>
                  <span class="ml-3 text-red-600">-{{ $n(discountAmount, 'currency') }}</span>
                </div>
              </template>
              <template v-else>
                <button v-if="!showCouponInput" @click="showCouponInput = true"
                  class="text-black text-xs text-right underline leading-5 tracking-tight">
                  Dodaj kupon
                </button>
                <div v-else class="flex items-center">
                  <input v-model="discountInput" type="text" placeholder="Kod rabatowy"
                    :class="`border px-2 py-1 text-sm w-32 focus:border-primary-500 focus:ring-primary-500 ${roundedClass} ${discountInput.trim() === '' ? 'border-gray-300' : 'border-gray-400'}`"
                    @keyup.enter="applyDiscount" />
                  <button @click="applyDiscount" :disabled="discountInput.trim() === ''"
                    :class="`ml-2 px-3 py-1 text-xs ' ${discountInput.trim() === '' ? 'text-gray-400 border-gray-300 cursor-not-allowed' : 'primary-button'} `">
                    Zastosuj
                  </button>
                </div>
              </template>

            </div>
          </dd>

        </div>
        <div v-if="discountError">
          <p class="text-red-600 text-right">{{ discountError }}</p>
        </div>
      </dl>
    </div>

    <!-- Divider -->
    

    
    <div class="flex items-center justify-between border-t border-gray-200 pt-6 text-gray-900 mt-4">
      <dt class="text-base">
        <div class="justify-center text-neutral-900 text-base font-semibold font-montserrat leading-relaxed">Razem
        </div>
      </dt>
      <dd class="font-medium text-gray-900 text-base">{{ $n(totalAmount, 'currency') }} </dd>
    </div>



  </div>

  
</template>


<script>
import { CalendarDaysIcon, MapPinIcon, UserGroupIcon, ClockIcon, AcademicCapIcon } from '@heroicons/vue/24/outline';
import Globals from '@shared/model/Globals.js';
import CountdownTimer from './CountdownTimer.vue';

export default {
  components: {
    CalendarDaysIcon,
    CountdownTimer,
    MapPinIcon,
    UserGroupIcon,
    ClockIcon,
    AcademicCapIcon
  },
  props: {
    order: {
      type: Object,
      required: true
    },
    usePadding: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Podsumowanie'
    },
    showDiscount: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    roundedClass() {
      return Globals.getRoundedClass();
    },
    showInsurance() {
      return false; // Temporarily disabled insurance display
      return this.order.insurance && Object.keys(this.order.insurance).length > 0;
    },
    discountApplied() {
      return this.order.discount && this.order.discount.code;
    },
    discountDescription() {
      return this.order.discount ? this.order.discount.description : '';
    },
    discountCode() {
      return this.order.discount ? this.order.discount.code : '';
    },
    participantsPrice() {
      return this.order.getParticipiantsPrice() ?? 0;
    },
    addOnsPrice() {
      return this.order.getAddOnsPrice() ?? 0;
    },
    insuranceAmount() {
      return this.order.getInsuranceAmount() ?? 0;
    },
    discountAmount() {
      return this.order.getDiscountAmount() ?? 0;
    },
    monthlyAmount() {
      return this.order.getMonthlyAmount() ?? 0;
    }
    ,
    totalAmount() {
      return this.order.getTotalAmount() ?? 0;
    }
  },
  data() {
    return {
      discountInput: '',
      discountError: '',
      showCouponInput: false
    };
  },
  methods: {
    onTrialSelection(event) {
      const isChecked = event.target.checked;
      this.order.setOnTrial(isChecked);

    },
    


    formatTime() {
      const hours = this.order.selectedGroup?.hours;
      if (hours && hours.length > 0) {
        const hour = hours[0];
        return `${hour.start} - ${hour.end}`;
      }
      return '';
    },

    async applyDiscount() {
      if (!this.discountInput || this.discountInput.trim() === '') {
        this.discountError = 'Kod rabatowy nie może być pusty';
        return;
      }

      this.discountError = '';

      try {
        await this.order.applyDiscount(this.discountInput.trim());
        this.discountInput = '';
      } catch (error) {
        this.discountError = error.message;
        this.discountInput = '';
      }
    },
    removeDiscount() {
      this.order.setDiscount(null);
      this.discountInput = '';
      this.discountError = '';
    }
  }
};
</script>
